import React,{useState, useEffect} from 'react'
import { Map, Draggable, Marker } from "pigeon-maps";
import { getAuthorization } from "../../../../axios/AxiosAut";
import { setAPIDetailsMapSupplier } from "../../../../redux/slices/statistics/statisticSlice";
import { useDispatch, useSelector } from "react-redux";

export default function MapforSupplier() {
  const dispatch = useDispatch();

  const [MapPointsActive, setMapPointsActive] = useState([]);
  const APIDetailsMapSupplier = useSelector(
    (state) => state.statistics.APIDetailsMapSupplier
  );

  const getMapData = () => {
    getAuthorization()
      .get(`dashboard/suppliers/get_customers_map/`)
      .then((res) => {
        console.log("supplier Map Points", res.data);
        setMapPointsActive(res.data.points);
        dispatch(setAPIDetailsMapSupplier(res.data));

      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  useEffect(() => {
    getMapData();
    console.log("MapPointsActive.....", MapPointsActive);
  }, []);
  const ActiveSupplier = [
    { lat: 21.03739, lng: 105.77504 },
    { lat: 21.04572, lng: 105.78116 },
    { lat: 21.04636, lng: 105.80536 },
    { lat: 21.047960909190476, lng: 105.80630377087259 },
    { lat: 21.045237345780784, lng: 105.81239774952348 },
    { lat: 21.04267394647741, lng: 105.81608846898814 },
    { lat: 21.03962985249739, lng: 105.82827642628997 },
  ];
  const InActiveSupplier = [
    { lat: 21.03739, lng: 106.7850456576 },
    { lat: 21.04572, lng: 106.781165656 },
    { lat: 21.04636, lng: 106.80536565656 },
    { lat: 21.047960909190476, lng: 106.8063 },
    { lat: 21.045237345780784, lng: 106.81239},
    { lat: 21.04267394647741, lng: 106.816088 },
    { lat: 21.03962985249739, lng: 106.82827},
  ];

 const handleMarkerClick = ({ event, payload, anchor }) => {
    console.log(`Marker #${payload} clicked at: `, anchor)
  }

  return (
    <div>
      <div style={{ height: "60vh", overflow: "hidden" }} className="">
        <Map defaultCenter={[21.03739, 105.7811634]} defaultZoom={10}>
          {MapPointsActive.map((p, i) => ( 
            <Marker
              key={i}
              anchor={[parseFloat(p.latitude), parseFloat(p.longitude)]}
              width={50}
              color="#1F78B4"
              // onMouseOver={handleover}
              // payload={city}
              // onClick={(payload) =>
              //   alert(
              //     `City: ${payload.payload.city} - Population: ${payload.payload.population}`
              //   )
              // }
              // onClick={() => {
              //   console.log("map here");
              //   return <div title="djdj">ddddddd</div>;
              // }}
            />
          ))}
          {InActiveSupplier.map((p, i) => (
            <Marker
              key={i}
              anchor={[parseFloat(p.lat), parseFloat(p.lng)]}
              width={50}
              color="#C1E6FF"
              // onMouseOver={handleover}
              // payload={city}
              // onClick={(payload) =>
              //   alert(
              //     `City: ${payload.payload.city} - Population: ${payload.payload.population}`
              //   )
              // }
              // onClick={() => {
              //   console.log("map here");
              //   return <div title="djdj">ddddddd</div>;
              // }}
              payload={1} onClick={handleMarkerClick}
            />
          ))}
          
        </Map>
        
      </div>
    </div>
  );
}

